import { render, staticRenderFns } from "./CurrentWeather.vue?vue&type=template&id=0f0566b4&scoped=true&lang=html&"
import script from "./CurrentWeather.vue?vue&type=script&lang=js&"
export * from "./CurrentWeather.vue?vue&type=script&lang=js&"
import style0 from "./CurrentWeather.vue?vue&type=style&index=0&id=0f0566b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0566b4",
  null
  
)

export default component.exports